export type StringAttrType = {
  nullable?: boolean;
  default?: string;
};

export const StringAttrTypeData: StringAttrType = {
  nullable: true,
  default: '',
};
